import { render, staticRenderFns } from "./scheduleRulesCard.vue?vue&type=template&id=b5c28352&scoped=true"
import script from "./scheduleRulesCard.vue?vue&type=script&lang=js"
export * from "./scheduleRulesCard.vue?vue&type=script&lang=js"
import style0 from "./scheduleRulesCard.vue?vue&type=style&index=0&id=b5c28352&prod&lang=less&scoped=true"
import style1 from "./scheduleRulesCard.vue?vue&type=style&index=1&id=b5c28352&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c28352",
  null
  
)

export default component.exports